export default __webpack_public_path__ + "static/media/I bet you can’t do this.f84a3246.mp4";